if (!window.annurCartLineActionsReady) {
  window.annurCartLineActionsReady = true;

  document.addEventListener(
    'click',
    async (event) => {
      const removeLink = event.target.closest('cart-items cart-remove-button a[href]');
      if (!removeLink) return;

      event.preventDefault();
      event.stopPropagation();

      const removeButton = removeLink.closest('cart-remove-button');
      if (removeButton?.dataset.annurMixDiscount === 'true') {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}discount/clear`, {
          credentials: 'same-origin',
          redirect: 'follow',
        });

        if (!response.ok) return;
      }

      window.location.assign(removeLink.href);
    },
    true,
  );
}
